var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _ellipse, _rect, _ellipse2, _ellipse3, _path31, _path32, _path33, _path34, _path35, _path36;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolutionFig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_6",
    "data-name": "Layer 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2201 2116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{isolation:isolate;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#cfcfcf;}.cls-5{clip-path:url(#clip-path-2);}.cls-6{fill:#fafafa;}.cls-7{clip-path:url(#clip-path-3);}.cls-8{fill:#adc3d8;}.cls-9{fill:#0c2030;}.cls-10{fill:#b7ceea;}.cls-11{fill:#71a0bf;}.cls-12{fill:#1a6691;}.cls-13{fill:#f0f4f7;}.cls-14{fill:#0a243a;}.cls-15{fill:#2b517f;}.cls-16{fill:#3a6689;}.cls-17{fill:#9bc2e0;}.cls-18{fill:#759eba;}.cls-19{fill:#264860;}.cls-20{fill:#1b435e;}.cls-21{fill:#325e93;}.cls-22{fill:#3a93dd;}.cls-23{fill:#106899;}.cls-24{fill:#c7dfe2;}.cls-25{fill:#b7ccce;}.cls-26{fill:#4a5f72;}.cls-27{fill:#5c92b7;}.cls-28{fill:#5fa1d3;}.cls-29{fill:#5384a5;}.cls-30{fill:#5e89bc;}.cls-31{fill:#5994c9;}.cls-32{fill:#69abe2;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2168.75,1431.12l-.94,40.65c-.29,12.26-8.33,24.36-24.17,33.5l.94-40.65C2160.42,1455.48,2168.46,1443.38,2168.75,1431.12Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.25,1447.88l.94-40.65c-.3,13,8.13,26.2,25.24,36.25l-.94,40.65C36.38,1474.08,28,1460.89,28.25,1447.88Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1168.21,2028.33l-.94,40.65c-32.65,18.85-86.55,18.3-119.79-1.21l1-40.65C1081.66,2046.63,1135.56,2047.18,1168.21,2028.33Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2168.75,1431.12l-.94,40.65c-.29,12.26-8.33,24.36-24.17,33.5l.94-40.65c15.84-9.14,23.88-21.24,24.17-33.5"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54.43,1443.48l-.94,40.65c-17.11-10.05-25.54-23.24-25.24-36.25l.94-40.65c-.3,13,8.13,26.2,25.24,36.25"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "2144.58 1464.62 2143.64 1505.27 1167.27 2068.98 1168.21 2028.33 2144.58 1464.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1048.43 2027.12 1047.48 2067.77 53.49 1484.13 54.43 1443.48 1048.43 2027.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1029.73,810c32.64-18.85,86.55-18.3,119.79,1.21l994,583.64c33.24,19.52,33.72,50.9,1.07,69.75l-976.37,563.71c-32.65,18.85-86.55,18.3-119.78-1.21l-994-583.64c-33.24-19.52-33.72-50.9-1.07-69.76Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1168.21,2028.33l-.94,40.65c-32.65,18.85-86.55,18.3-119.79-1.21l1-40.65c33.23,19.51,87.13,20.06,119.78,1.21"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "back_hand",
    "data-name": "back hand",
    className: "cls-8",
    d: "M533,607c-5,29-8,62-7,77s11,40,21,44,19,8,61,0,201-44,221-52,68-45,51-43-30-26-30-26-15,7-60,27-185,34-193,0S533,607,533,607Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "backsh",
    className: "cls-9",
    d: "M554.69,1430.14c4.42-2.34,46.88-4,59.16-2.53s46.64,2.09,54,4.18,20.31,3,24.23,16c3.51,11.65-1.42,20.35-19,24.62a578.45,578.45,0,0,1-57.15,10.34c-16.87,2.16-35.59,5.56-44.64,5.71-5,.08-15,.91-18.51-10.74s-6.18-32.47-6.18-32.47S547.14,1434.13,554.69,1430.14Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "backleg",
    className: "cls-10",
    d: "M555.49,1424.3a17.2,17.2,0,0,0,3.62,8.85c3.16,4,8.12,9.59,11.89,10.85,6,2,18,4,26,0s8-41,9-50,6-51,11-69,23-126,39-147c7.3-9.58,40-91,3-98s-81-5-81-5-8,91-9,114-8,88-8,100-6,69-6,79C555,1382.45,554.22,1412.3,555.49,1424.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "fornt_le",
    "data-name": "fornt le",
    className: "cls-10",
    d: "M624,1470s10,4,26,3l32-2s0-57,1-83,10-82,17-104,33-114,34-128-35-51-35-51l-48,9s-2,60-5,84-17,108-17,125S624,1470,624,1470Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "front_sh",
    "data-name": "front sh",
    className: "cls-9",
    d: "M649.85,1526.18a21.89,21.89,0,0,0,9-2.23c12.2-5.93,30.06-10.29,42.14-14,13.43-4.07,48.3-9.36,55-16s14.13-16,13-20.88-5.88-17.82-18-17.12-26,3.86-34,5c-6.79,1-18.3-1.83-32.59-.18a21.52,21.52,0,0,0-2.5.46c-7.46,1.82-18.11,7.76-28.91,9.72-13.45,2.44-26.66.6-28.89-1-4.11-3-8.85,12.34-5.76,26s5.54,27.33,10.65,29C633.05,1526.35,643.5,1526.33,649.85,1526.18Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "hnad_fornt",
    "data-name": "hnad fornt",
    className: "cls-10",
    d: "M761,670.83a23.26,23.26,0,0,0-6.64,17.33C755.94,722,760.82,756.64,769,783c9,29,25,74,36,94,10.85,19.72,18.77,55,17.08,89.52a22.48,22.48,0,0,0,0,3C824.35,996.21,833.89,1002,837,1002c6,0,14.82-18,18.48-23.28q.56-.79,1-1.62c6.72-11.28,11.51-15.22,13-58.06.31-4.72-.55-9-1.73-14C861.25,877.64,847.37,856.59,840,840c-8-18-23.78-76.26-28-109-1.71-13.28-4.71-33-7.58-51.18a23.37,23.37,0,0,0-39.8-12.69Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "face",
    className: "cls-10",
    d: "M750,535c-34-26-54-46-56-54s-6-32,11-35,34-10,35-29-2-48-5-57c-2.24-6.71-12-38-22-41s-56,39-66,58,14,100,10,120,2,60,2,60Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "clothe",
    className: "cls-11",
    d: "M628,490c56,6,128,39,140,43s32,14,32,44,7,113,8,115-50,3-50,3a342.4,342.4,0,0,0,4,49c4,24,21,76,21,76s-4,97-6,115-12,105-18,141-16,82-16,82-60,6-93,0-71-48-71-48-11-78-17-117-9-107-6-135,32-140,38-179S628,490,628,490Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "hair",
    className: "cls-12",
    d: "M559,452c8-14-2-102-2-102s4-39,25-57c22.79-19.53,31-30,78-27s62,25,68,41,0,54-3,62c-1.12,3-5.34,5.86-10.18,8.26A65.9,65.9,0,0,1,685.45,384S667,379,659,384c-5,2-2,34,13,36s9,29,9,29-21,32-27,63-14,63-12,87,3,87,0,102c-10,29-27,13-40,0-17-2-42-35-46-65s-54-30.65-60.51-17.33-16.78-6.95-16.62-16.12C479.33,575.24,496,523,508,509S551,466,559,452Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "righghand",
    className: "cls-10",
    d: "M1269.06,665.45c-6.06,18.55-15.89,28.76-16.48,44.66S1257,747,1261,734s6-58,8,29c.51,22.35,15,39,21,27s26-39,23-60-14-77-14-92-31,0-31,0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "lefthadn",
    className: "cls-10",
    d: "M884,559c-21,3-33,23-39,30-4.37,5.09-6,8-6,14,0,17.09-5,23-2,34s2,25,11,23,15-7,36-21,14-36,24-51S884,559,884,559Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "shirt",
    className: "cls-13",
    d: "M1051,549c1,32,39,67,59,67s103-34,103-34l-13-163,13-125s-6-52-17-53-22-21-29-17-19,16-32,19c-19.41,4.48-30,5-29-4s-25-1-25,8S1051,549,1051,549Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "tie",
    className: "cls-14",
    d: "M1091,541c5-1,25-28,25-32s-4-228,0-232,12,0,12,0,8-12,4-16-13-13-17-15-12,1-13,4,5,15,5,17-38,227-38,231,13,34,15,37S1091,541,1091,541Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "leftshe",
    className: "cls-15",
    d: "M1055,1269c19-2,30-10,43-21s38-14,44-14,26,0,24-15,2-32,0-36,7-13-8-9-13,10-27,11-33-10-36-8-40,25-49,33-28,16-28,16-21,17-12,26S1055,1269,1055,1269Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "right_shoe",
    "data-name": "right shoe",
    className: "cls-15",
    d: "M1218,1225c-4,21,3,59,0,72s-7,44-1,53,9,15,16,15,31,2,38-15,12-39,9-55-12-46-12-55-3-30-3-30h-42Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "legs",
    className: "cls-16",
    d: "M1043,823c4,78,14,137,20,187s27,136,29,145,1,19,3,22,22,9,29,10,35-11,34-10-4-94-9-125-12-125-13-153-3-68-2-76,12-19,13-4,26,165,30,189,23,90,26,117,5,100,5,100,17,2,32,2,33-3,35-4-9-125-13-165-6-130-7-160-4-188-12-237-11-77-11-77-1,0-30,3-82,0-110-13-39-27-41-25-1,30-4,69-11,107-9,147S1043,823,1043,823Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "coathrighgt",
    className: "cls-17",
    d: "M1032,788c7,2,10-19,13-90s11-193,14-233,18-188,25-200,14-29,22-37,47-27,13-26-78-2-97,20-38,49-42,67-18,121-24,130-33,56-40,68-39,68-43,71,0,15,5,21,24,22,27,19,89-114,97-133,26-47,29-55-14,110-17,131-20,165-22,185-4,48,4,51S1032,788,1032,788Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "coathleft",
    className: "cls-17",
    d: "M1187,279c-4,27-7,60-12,93s-1,152,0,177-3,163-2,183,0,53,14,46,52-63,58-80,6-34,10-35,49,5,51,2,16-125,15-170-4-134-12-155-32-57-53-75-65-44-78-46-48,2-20,13S1187,279,1187,279Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "rightcoatshado",
    className: "cls-18",
    d: "M1237,459c0-12-7-34-12-48s-7-34-7-34,8-12,19,13,10,30,11,44,3,97,0,121-10,35-10,0S1237,459,1237,459Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "leftcoatshado",
    className: "cls-18",
    d: "M1037.64,360c-12.26,37.14-27.25,86.39-26.44,85.14C1041,399,1027,414,1026,454c0,.74,31.84-147.69,22.46-125.29S1037.64,360,1037.64,360Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "face-2",
    "data-name": "face",
    className: "cls-10",
    d: "M1109,246c11,7,16,6,28,0,6.42-3.21,15.69-7.56,23.85-12.75,7.1-4.52,4.23-35.28,10.15-37.25,12-4,12-23,12-34s4-38-5-46-19-25-36-26-69-7-74-4-2,71,0,90,9,34,15,42c3.23,4.31,14,7.73,20,14C1108.17,237.36,1109,246,1109,246Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "hgair",
    className: "cls-19",
    d: "M1061,49.75a26.56,26.56,0,0,0-2.74,28.71c2.82,5.41,6.41,9.54,9.76,9.54,7,0,48-1,60,3s33-3,43,25,4,34,4,40,0,18,2,18,10-22,16-33,12-27,13-39,3-41-7-52-23-28-59-27-57,2-63,7C1073.32,33.07,1068.22,40.56,1061,49.75Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "leftshe-2",
    "data-name": "leftshe",
    className: "cls-20",
    d: "M1300.5,1626.5c8,10,4,20,45,21s89,0,89,0v12s44,5,54,0,17-23,15-41-1-53-6-61-20-39-20-39h-42l-7,48s-13,13-26,13-60,0-69,3-30,13-33,20S1300.5,1626.5,1300.5,1626.5Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "rightsheo",
    className: "cls-20",
    d: "M1529.3,1502.87c20.63,13,47.2,31.63,47.2,31.63l15,23s7,5,33,0,29-10,26-18-1-55-8-80-54-30-54-30-15,20-24,26-18-1-24-6-9-5-15,3c-8.59,11.45-13,21-10,27,2,4,5.8,12,8.09,16.93A15.33,15.33,0,0,0,1529.3,1502.87Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "pants",
    className: "cls-21",
    d: "M1404.5,1549.5c31,18,66,12,93,0s2-223,0-259-4.79-132.23-2-149c2-12,13-107,14,12,.23,27.29,8,61,16,99s18,70,24,122,10,77,17,84,14,29,28,27,57-13,60-21-11-95-19-152-25-90-21-144,9-117,9-147-6.08-105.25-12-125c-9-30-27-19-45-16s-39,44-78,44-74,5-92-11,0,44,0,88-10,203-8,245S1404.5,1549.5,1404.5,1549.5Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "righthand",
    className: "cls-10",
    d: "M1626.5,786.5c-13,7-29,24-35,32s-13,17-5,31,7,37,18,31,21-11,23-21c8.38-41.92,2-25,9-48S1626.5,786.5,1626.5,786.5Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "lefthand",
    className: "cls-10",
    d: "M1126.5,764.5c21,20,52,43,77,53s35,8,41,0c6.18-8.24,14-9-5-27s-16.19-21.52-28-43c-11-20-31-35-17-6,16.88,35,.31,20.22-21,9-19-10-27-14-48-14C1108,736.5,1126.5,764.5,1126.5,764.5Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "head",
    className: "cls-10",
    d: "M1455.5,599.5c2-24,7-28,5-41s1-16-10-19-24,4-30-8-13-21-9-38,5-67,9-74,7-25,24-20,89,18,85,49-12,64-15,75-3,19,6,23,15,13,15,13-3,31-17,40S1455.5,599.5,1455.5,599.5Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "shirt-2",
    "data-name": "shirt",
    className: "cls-22",
    d: "M1213.5,835.5c9,7,60,44,89,59s54,20,61,0,34-80,33-53-8,75-9,82,55,15,109,6,109-35,116-45-5-24-12-50-9-84-10-88-1-64,3-66,29-7,26,0-3.79,88.89-5,101c-1,10-6,12,5,17s20,14,22,7,28-53,40-97,27-39,0-77-60-74-80-81-66-2-72,0-9,33-17,38-59-1-69,3-47,16-64,45-38,101-42,113-23,69-27,72-57-31-59-32-24,2-29,8S1213.5,835.5,1213.5,835.5Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "hair-2",
    "data-name": "hair",
    className: "cls-23",
    d: "M1471.5,524.5c-4-3-1-9,8-8s11-9,10-16-2-17-10-18-9,19-17,21-13-5-12-21,2-27,9-34,0-23-4-31-18-10-23-12c-3.35-1.34-16-15-14-21s38-17,63-16,63,14,71,25,30,64,10,93-42,45-51,48-14,4-22,0S1471.5,524.5,1471.5,524.5Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 1084.5,
    cy: 1876,
    rx: 100.5,
    ry: 44
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 984,
    y: 1763,
    width: 201,
    height: 113
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 1084.5,
    cy: 1766,
    rx: 100.5,
    ry: 34
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "dirt",
    className: "cls-26",
    cx: 1085,
    cy: 1767,
    rx: 84,
    ry: 26
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "thunk",
    className: "cls-27",
    d: "M1049.34,1765.5c4.81,7,6.41,13,19.23,14s12,7,25.64-4,13.63,0,17.63-25,.37-18.5.19-45.25,9.43-59.75,4.62-76.75,6.41-22-22.44-33-70.51-41-69.71-18-1.16,15.67,9.83,51.33S1049.34,1765.5,1049.34,1765.5Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "leaf3",
    className: "cls-28",
    d: "M936.5,1763.5c6-15,15-28,29-43s18-21,40-26,49-49,31-66-18-27-33-40-51-25-63-9-16,54-15,82S936.5,1763.5,936.5,1763.5Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "leaf2",
    className: "cls-29",
    d: "M1103,1613c-9,1-20.5,34.5-9.5,52.5s3,27,37,33,60,50,71,78,7-56,12-71,24-32,27-46,8-85-46-81S1103,1613,1103,1613Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "leaf1",
    className: "cls-30",
    d: "M1069,1591c-13-3-49.5,6.5-55.5,18.5s-12,28,0,45,28,28,33,41,11,35,11,40,14-30,24-48,37-29,34-39-5-27-13-36S1069,1591,1069,1591Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "leaf4",
    className: "cls-31",
    d: "M957.5,1525.5c1,33,19,131,26,140s21-2,36-32,33-42,44-48,44-38,20-46-40-4-40-4,4-24-8-30-42-27-58-12S957.5,1525.5,957.5,1525.5Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "leaf3-2",
    "data-name": "leaf3",
    className: "cls-32",
    d: "M1096.5,1549.5c-6,3-29-2-40,0s-26,31-14,39,52,24,62,30,49,53,53,65,7-82,7-89,9-50,0-63-40-22-51-16S1096.5,1549.5,1096.5,1549.5Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionFig);
export default __webpack_public_path__ + "static/media/solutionFig.eee7a368086b70dd5970ed38d5ac2ee4.svg";
export { ForwardRef as ReactComponent };